
<div class="w2-confirm-choice-box col-xs-12 text-center">
	<h1>{{{viewTitle}}}</h1>
	<p>{{{message}}}</p>
</div>


